import axios from '@/utils/request';

// 密码登录
export const loginPwd = (data) => {
    return axios.post('/auth/login', data)
}